export default __webpack_public_path__ + "158308e710a1a6da89943b3d62e73bb6.png";